import splashMiddleware from "./src/middlewares/splash";

export default {
  paths: { template: "./public/index.html" },
  plugins: [
    "@uvue/core/plugins/asyncData",
    [
      "@uvue/core/plugins/vuex",
      {
        onHttpRequest: true,
        fetch: true
      }
    ],
    [
      "@uvue/core/plugins/middlewares",
      {
        middlewares: [splashMiddleware]
      }
    ],
    "@uvue/core/plugins/errorHandler",
    "@uvue/core/plugins/prefetch",
    "@/plugins/axios",
    "@/plugins/navLoader",
    "@/plugins/firebase"
  ]
};
